import React, { useEffect } from 'react'

import { useOrderItemsModule } from '../../../OrderForm/contexts/OrderItemsModuleContext'
import type { ProductApiData } from '../types'

interface FashionHydrationBridgeProps {
  loadedItems?: { products: ProductApiData[]; kitCount: number }
}

/** Entrega os itens carregados ao módulo — o ponto de entrada que o contrato define. */
const FashionHydrationBridge: React.FC<FashionHydrationBridgeProps> = ({ loadedItems }) => {
  const { hydrate } = useOrderItemsModule()

  useEffect(() => {
    if (loadedItems) hydrate(loadedItems)
  }, [loadedItems, hydrate])

  return null
}

export default FashionHydrationBridge
